<template>
  <el-row class="links__row home__section">
    <el-col
      :xs="{ span: 18, offset: 3 }"
      :sm="{ span: 14, offset: 5 }"
      :md="{ span: 14, offset: 5 }"
      :lg="{ span: 14, offset: 5 }"
      :xl="{ span: 12, offset: 6 }"
    >
      <h4 class="links__heading">網站連結</h4>

      <el-row :gutter="30">
        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
          <div class="links__link-wrapper">
            <a :href="sites.teaching.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper links__icon-wrapper__lg">
                <img src="@/assets/images/teaching.png" :alt="sites.teaching.name" class="links__img-teaching">
              </span>
              <span class="links__title">{{ sites.teaching.name }}</span>
            </a>
          </div>
        </el-col>

        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
          <div class="links__link-wrapper">
            <a :href="sites.mobile.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper links__icon-wrapper__lg">
                <img src="@/assets/images/mobile.png" :alt="sites.mobile.name" class="links__img-mobile">
              </span>
              <span class="links__title">{{ sites.mobile.name }}</span>
            </a>
          </div>
        </el-col>

        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
          <div class="links__link-wrapper">
            <a :href="sites.eshop.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper links__icon-wrapper__lg">
                <img src="@/assets/images/eshop.png" :alt="sites.eshop.name">
              </span>
              <span class="links__title">{{ sites.eshop.name }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data () {
    return {
      sites: {
        teaching: {
          name: '空英增能學堂',
          url: 'https://www.facebook.com/Teaching.SC/'
        },
        mobile: {
          name: '空英行動版網站',
          url: 'http://m.studioclassroom.com/'
        },
        eshop: {
          name: '空英購物商城',
          url: 'https://shop.studioclassroom.com/'
        }
      }
    }
  }
}
</script>
